// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rg2Eqk78Ebeb8IHOmYkS {
  display: flex;
  align-items: stretch;
  width: 100%;
  height: 100%;
  background-color: var(--background);
}
.rg2Eqk78Ebeb8IHOmYkS > div {
  overflow-x: auto;
}
.rg2Eqk78Ebeb8IHOmYkS > div > * {
  max-height: 100%;
  height: 100%;
}
.rg2Eqk78Ebeb8IHOmYkS > div:first-child {
  flex: calc(50% - var(--dry-resizer-width) / 2) 0 0;
}
.rg2Eqk78Ebeb8IHOmYkS > div:last-child {
  flex: 100% 1 1;
}
.rg2Eqk78Ebeb8IHOmYkS > i {
  flex: var(--dry-resizer-width) 0 0;
  background-color: var(--dry-resizer-color);
  cursor: col-resize;
  position: relative;
}
.rg2Eqk78Ebeb8IHOmYkS[data-vertical="true"] {
  flex-direction: column;
}
.rg2Eqk78Ebeb8IHOmYkS[data-vertical="true"] > div {
  overflow-y: auto;
}
.rg2Eqk78Ebeb8IHOmYkS[data-vertical="true"] > i {
  cursor: row-resize;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `rg2Eqk78Ebeb8IHOmYkS`
};
export default ___CSS_LOADER_EXPORT___;
